import React from "react";
import { Link } from "react-router-dom";

import "./Home.css";

import headshot from "../../assets/img/headshots/headshot-transparent.png";

// Email teamplate for email me button!
const emailTemplate = {
  mailto: "awilliams7529@gmail.com", //  '' or 'mail1' or 'mail1, mail2, mail3' [No trailing comma]
  cc: "", //  '' or 'mail1' or 'mail1, mail2' [No trailing comma at the end of the list]
  bcc: "", // '' or 'mail1' or 'mail1, mail2' [No trailing comma at the end of the list]
  subject: "Inquiry From chillyssa.github.io",
  body: "Hey Alyssa!%0D%0A%0D%0AI am reaching out to inquire about [specific topic or question]. I came across your website and was particularly interested in [specific aspect or resource].%0D%0A%0D%0ACould you please provide more information on [specific request or question]?%0D%0A%0D%0AThanks!%0D%0A[Your Name]%0D%0A[Your Affiliation, if applicable]%0D%0A[Your Contact Information]",
};

function scrollToTop() {
  window.scrollTo(0, 0);
}

function Home() {
  return (
    <div className="container">
      <section className="row my-5">
        {/* Profile Section */}
        <div className="col-xs-12 col-lg-5 order-2 order-lg-1 profile-section d-none d-md-flex justify-content-center justify-content-lg-end">
          <div className="profile-image-wrapper me-5">
            <img
              src={headshot}
              alt="Alyssa Williams"
              className="profile-image img-fluid"
            />
          </div>
        </div>
        <div className="col-xs-12 col-lg-7 order-1 order-lg-2">
          {/* Introduction Section */}
          <h1 className="display-1">Hello World</h1>
          <h2 className="mt-3 mb-4">{"< A Bit About Me />"}</h2>
          <div className="bio-section">
            <p className="fs-5">
              Welcome, I'm Alyssa! I am a software and web application developer
              based in Denver, CO. Currently, I'm pursuing my master's degree in
              Computer Science at the University of Colorado Boulder, where I'm
              expanding my expertise in advanced technologies and innovative
              problem-solving.
            </p>
            <p className="fs-5">
              With a decade of experience in the hospitality industry, I bring a
              unique perspective to the tech world, blending creativity with
              technical acumen. My journey into programming began with a dabble
              in WordPress site management, and I haven't looked back since. I
              thrive on developing solutions that are not only functional but
              also accessible, with a strong focus on UI/UX design to ensure a
              seamless user experience.
            </p>
            <p className="fs-5">
              When I'm <strong>{"< AFK />"}</strong> you'll likely find me in
              the kitchen, experimenting with new recipes, baking something
              sweet, or perfecting the art of kneading sourdough. Cooking is my
              creative outlet, where I apply the same passion for precision and
              innovation that I bring to my coding projects.
            </p>
          </div>
          {/* Buttons Section */}
          <div className="buttons-section d-flex justify-content-center justify-content-lg-left my-5">
            <Link
              to="/resume"
              className="btn btn-green-lt mx-3"
              onClick={scrollToTop}
            >
              Resume
            </Link>
            <Link
              to="/projects"
              className="btn btn-success mx-3"
              onClick={scrollToTop}
            >
              Projects
            </Link>
            <a
              id="contact-me"
              href={`mailto:${emailTemplate.mailto}?cc=${emailTemplate.cc}&bcc=${emailTemplate.bcc}&subject=${emailTemplate.subject}&body=${emailTemplate.body}`}
              className="btn btn-warning mx-3"
            >
              Email Me!
            </a>
          </div>
        </div>
      </section>

      {/* Contact Section
      <section id="contact-section" className="text-center mt-5">
        <h2>Contact</h2>
        <p>Feel free to reach out to me!</p>
        <p>
          <strong>Phone:</strong>{" "}
          <a href="tel:+17204703778" className="text-dark">
            720-470-3778
          </a>
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:awilliams62090@gmail.com" className="text-dark">
            awilliams7529@gmail.com
          </a>
        </p>
      </section> */}
    </div>
  );
}

export default Home;
